import { Injectable, signal } from '@angular/core';
import { zxcvbnAsync, zxcvbnOptions, ZxcvbnResult } from '@zxcvbn-ts/core';
import * as zxcvbnCommonPackage from '@zxcvbn-ts/language-common';
import * as zxcvbnEnPackage from '@zxcvbn-ts/language-en';

@Injectable({
  providedIn: 'root'
})
export class ZxcvbnService {
  readonly score = signal<number>(0);

  constructor() {
    zxcvbnOptions.setOptions({
      graphs: zxcvbnCommonPackage.adjacencyGraphs,
      useLevenshteinDistance: true,
      translations: zxcvbnEnPackage.translations,
    });

    // Override the default sequence matcher
    // to allow 1234567, abcdef, etc.
    zxcvbnOptions.addMatcher('sequence', {
      Matching: class {
        match() { return []; }
      },
      feedback() { return { warning: '', suggestions: [] }; },
      scoring() { return 1; },
    });
  }

  async check(password: string): Promise<ZxcvbnResult> {
    const result = await zxcvbnAsync(password);
    this.score.set(result.score);
    return result;
  }
}
